var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutRtImg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 268,
    viewBox: "0 0 276 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.293 216.293C226.632 192.895 246.481 137.119 223.627 91.7139C200.772 46.3084 143.869 28.4674 96.5296 51.865C49.1905 75.2625 29.3417 131.038 52.1963 176.444C75.0508 221.849 131.954 239.69 179.293 216.293Z",
    stroke: "#FAC825",
    strokeWidth: 8.54196,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.108 215.995C202.871 204.24 203.691 158.035 180.939 112.794C158.187 67.5526 120.478 40.4071 96.7147 52.1626C72.9509 63.9181 72.1308 110.123 94.8829 155.364C117.635 200.605 155.344 227.751 179.108 215.995Z",
    stroke: "#FAC825",
    strokeWidth: 8.54196,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2812 52.2596L178.508 215.982",
    stroke: "#FAC825",
    strokeWidth: 8.54196,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutRtImg4);
export default __webpack_public_path__ + "static/media/about-rt-img4.6788c3b95b2f0816164d871a4136b299.svg";
export { ForwardRef as ReactComponent };